@if (field) {
  <div class="modal fade" id="edit-client-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        @if (field === 'name') {
          <div class="modal-body">
            <label>Name <span class="text-danger small">(required)</span></label>
            <input class="form-control" [ngClass]="setClassInvalidTpl(name)" #name="ngModel" type="text"
              [(ngModel)]="client.name" placeholder="Client name" required>
          </div>
        }
        @if (field === 'cluster') {
          <div class="modal-body">
            <label>Topic <span class="text-danger small">(required)</span></label>
            <select class="form-control" name="cluster" [(ngModel)]="client.cluster" required>
              <option value="" selected disabled>Select topic</option>
              @for (cluster of clusters; track cluster) {
                <option [value]="cluster">{{cluster}}</option>
              }
            </select>
          </div>
        }
        @if (field === 'category') {
          <div class="modal-body">
            <label>Category <span class="text-danger small">(required)</span></label>
            <select class="form-control" name="category" [(ngModel)]="client.category" required>
              <option value="" selected disabled>Select category</option>
              @for (category of categories; track category) {
                <option [value]="category">{{category}}</option>
              }
            </select>
          </div>
        }
        @if (field === 'image') {
          <div class="modal-body">
            <label>Image <span class="text-danger small">(required)</span></label>
            <input type="url" class="form-control" [ngClass]="setClassInvalidTpl(image)" #image="ngModel" name="image"
              [(ngModel)]="client.image" [pattern]="urlRegexp" placeholder="https://utopia-images.s3.eu-central-1.amazonaws.com/clients/example.jpg"
              required>
          </div>
        }
        @if (field === '_users') {
          <div class="modal-body">
            <label class="me-1">Coordinators:</label>
            <app-search-input [items]="client._users" model="user"></app-search-input>
          </div>
        }
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="!client.name || !client.cluster" (click)="updateClient(field)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}